import { ElectronicFormDataGridStringValidator } from "utils/ElectronicFormDataGridStringValidator";
import { ElectronicFormNonGridValidator } from "utils/ElectronicFormNonGridValidator";

export const HandleSubmitGroupView = (Data) => {
  const FinalDataArray = Data.map((datalist) => {
    if (datalist.element.ElsRecord.Type === "PictureBox") {
      return {
        iddetail: datalist.iddetail,
        base64: datalist.value.fileContent,
        value: "",
      };
    }
    if (datalist.element.ElsRecord.Type === "DataGridView") {
      if (datalist.value.length > 0) {
        return ElectronicFormDataGridStringValidator(datalist.value, datalist);
      } else {
        return {
          idcommand: "",
          value: "",
          base64: "",
          iddetail: datalist.iddetail,
        };
      }
    } else {
      return ElectronicFormNonGridValidator(datalist);
    }
  });
  return FinalDataArray;
};
